// NATIVE
import * as React from 'react';

// INSTALLED
import { Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// CUSTOM
import { DetailLog } from '../../logs/detail';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

/**
 * DetailDialogLog component renders a dialog with detailed log information.
 *
 * @param {object} props - The properties object.
 * @param {boolean} props.open - Determines if the dialog is open.
 * @param {function} props.handleCloseModalDetailLog - Function to handle closing the dialog.
 * @param {boolean} [props.buttons=false] - Optional flag to show buttons.
 * @param {any} props.data - Data to be displayed in the dialog.
 *
 * @returns {JSX.Element} The rendered DetailDialogLog component.
 */
export const DetailDialogLog = (props: any) => {
  // PROPS
  const { open, handleCloseModalDetailLog, buttons = false, data } = props;

  // CONST FUNCTIONS
  const handleClose = () => {
    handleCloseModalDetailLog(false);
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Detalle Log
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid>
            <DetailLog />
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};
